import React, { lazy } from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-6 sm:pt-10 sm:pb-12 px-4 overflow-hidden flex flex-col justify-center bg-brand-sage-light" data-id="element-72">
      <div className="max-w-2xl mx-auto text-center" data-id="element-73">
        <h1 className="text-2xl sm:text-4xl md:text-5xl font-serif font-bold text-brand-text-main leading-[1.15] mb-3 sm:mb-5" data-id="element-74">
          Smettila di sentirti gonfia e pesante. Ritrova la tua linea con il
          sistema "Reset" Mediterraneo.
        </h1>

        <p className="text-sm sm:text-lg text-brand-text-muted leading-relaxed mb-4 sm:mb-6 max-w-xl mx-auto font-medium" data-id="element-75">
          Il primo sistema di trasformazione alimentare che ha semplificato la
          vita a oltre 1.500 persone in Italia. Risparmia tempo, mangia con
          gusto e sgonfia l'addome per sempre.
        </p>

        <h2 className="text-base sm:text-xl font-bold text-brand-olive mb-4 sm:mb-6" data-id="element-76">
          Addio al Gonfiore Addominale: Sgonfiati in soli 21 Giorni.
        </h2>

        <div className="mb-4 sm:mb-6" data-id="element-77">
          <a href="#pricing" className="block cursor-pointer" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/mR2T6m8uej97hkUxQGCs1i/reset-mediterraneo.webp" alt="Reset Mediterraneo - Addio al Gonfiore in 21 Giorni" loading="lazy" className="w-full h-auto object-contain" data-id="element-79" />
          </a>
        </div>

        <div data-id="element-80">
          <CTAButton className="w-full sm:w-auto sm:min-w-[300px]" variant="primary" data-id="element-81">
            🚀 SÌ, VOGLIO IL MIO RESET ORA
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 mt-3 sm:mt-5 text-[10px] sm:text-sm text-brand-text-muted font-medium" data-id="element-82">
          <span data-id="element-83">Accesso immediato</span>
          <span className="text-brand-text-muted/50" data-id="element-84">•</span>
          <span data-id="element-85">Pagamento sicuro</span>
          <span className="text-brand-text-muted/50" data-id="element-86">•</span>
          <span data-id="element-87">Garanzia 7 giorni</span>
        </div>
      </div>
    </section>;
}